import React, { useRef, useEffect } from "react";
import { LottieRefCurrentProps } from "lottie-react";

type Props = {
  speed?: number;
};

const useLottieRef = ({ speed = 1 }: Props = { speed: 1 }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (lottieRef.current) {
      //console.log(speed);
      lottieRef.current.setSpeed(speed);
    }
  }, [speed]);

  return lottieRef;
};

export default useLottieRef;
